import Vue from "vue";
const envType = process.env.VUE_APP_CURRENTMODE
let baseURL = {}
if (process.env.NODE_ENV === 'development' || envType === 'stage') {
    // 开发环境 || 测试
    baseURL.AHEAD = ' http://test-biz.blackrocknovel.com'
    baseURL.IMG = "http://test-img.blackrockread.com"
} else if (envType === 'prod') {
    // 生产
    baseURL.AHEAD = 'https://biz.blackrocknovel.com'
    baseURL.IMG = "https://img.meetnovel.com"
    Vue.prototype.isShowA = false;
} else {
}

export default baseURL
